
    import * as React from 'react';

    const ChevronUp20 = ({ color = 'currentcolor', height = '20px', width = '20px', ...rest }) => {
      const svgStyle: React.CSSProperties = {...{"position":"absolute","top":"0","right":"0","bottom":"0","left":"0","width":"100%","height":"100%"}, fill: color};

      return (
        <div style={{ ...{"position":"relative"}, height, width }} { ...rest }>
          <svg viewBox="0 0 20 20" style={svgStyle}><path d="M2.11 14.165l-.887-.883 8.7-8.726 8.845 8.723-.877.89-7.96-7.85z" /></svg>
        </div>
      );
    };

    ChevronUp20.displayName = 'ChevronUp20';

    export default ChevronUp20;
  